const PRODUCTION_SOCIAL_URL = 'https://social.marketos.click';
const LOCAL_SOCIAL_URL = 'http://localhost:5174';

const isLocalHost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

const SOCIAL_URL = (process.env.REACT_APP_SOCIAL_URL
  || (isLocalHost ? LOCAL_SOCIAL_URL : PRODUCTION_SOCIAL_URL)).replace(/\/+$/, '');

export function socialUrlWithToken(token) {
  if (!SOCIAL_URL || !token) return null;
  const url = new URL(SOCIAL_URL);
  url.searchParams.set('token', token);
  return url.toString();
}

export default SOCIAL_URL;
